import { render, staticRenderFns } from "./EndControl.vue?vue&type=template&id=240634c3&scoped=true&"
import script from "./EndControl.vue?vue&type=script&setup=true&lang=ts&"
export * from "./EndControl.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./EndControl.vue?vue&type=style&index=0&id=240634c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240634c3",
  null
  
)

export default component.exports